var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Classes.XmlModel = new Class({
    Extends: OCS.Viewer.Classes.AbstractModel,
    class_name: "XmlModel",
    options: {},
    pre_process: function () {
        if (this.input && OCS.Utilities.is_string(this.input)) {
            this.setOptions(this.decode_string_xml_to_json(this.input));
            this.input = null;
        }
        this.parent();
    },  
    decode_string_xml_to_json: function(str) {
        return OCS.Utilities.xml_to_json(OCS.Utilities.xml_string_to_xml(str), {no_text: true});
    }
}); // End OCS.Viewer.Classes.AbstractModel
